import { defineMessages } from 'react-intl';

export const translations = defineMessages({
    since: {
        id: 'Experiences.backCard.dates.since',
        defaultMessage: 'Since {year}'
    }
});
